module.exports = __webpack_public_path__ + "static/media/spinner.1cd31a1f.gif";